module.exports = __webpack_public_path__ + "img/landown.f005c879.svg";